export const INITIAL_STATE = {
  error: null,
  loading: false
};